import { render, staticRenderFns } from "./DesignatedAdd.vue?vue&type=template&id=319a398e&scoped=true"
import script from "./DesignatedAdd.vue?vue&type=script&lang=js"
export * from "./DesignatedAdd.vue?vue&type=script&lang=js"
import style0 from "./DesignatedAdd.vue?vue&type=style&index=0&id=319a398e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319a398e",
  null
  
)

export default component.exports